import {Injectable} from '@angular/core';
import {Actions} from '@ngrx/effects';

@Injectable()
export class ConfigEffects {

  // @Effect()
  // getConfig$ = this._actions$.pipe(
  //     ofType<GetConfig>(EConfigActions.GetConfig),
  //     switchMap(() => this._configService.getConfig()),
  //     switchMap((config: IUISceneConfig) => {
  //         return of(new GetConfigSuccess(config));
  //     })
  // );

  // constructor(private _configService: ConfigService, private _actions$: Actions) {
  constructor(private _actions$: Actions) {}
}
